/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports['default'] = connectData;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

/*
	Note:
	When this decorator is used, it MUST be the first (outermost) decorator.
	Otherwise, we cannot find and call the fetchData and fetchDataDeffered methods.
*/

function connectData(fetchData, fetchDataDeferred) {
	return function wrapWithFetchData(WrappedComponent) {
		var ConnectData = (function (_Component) {
			_inherits(ConnectData, _Component);

			function ConnectData() {
				_classCallCheck(this, ConnectData);

				_Component.apply(this, arguments);
			}

			ConnectData.prototype.render = function render() {
				return _react2['default'].createElement(WrappedComponent, this.props);
			};

			return ConnectData;
		})(_react.Component);

		ConnectData.fetchData = fetchData;
		ConnectData.fetchDataDeferred = fetchDataDeferred;

		return _hoistNonReactStatics2['default'](ConnectData, WrappedComponent);
	};
}

module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/connectData.js
 ** module id = 67
 ** module chunks = 0
 **/